import React from 'react';
import { ListColumnType, ListFilterType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import FormTemplateLibraryModal from './FormTemplateLibraryModal';

const FormList: React.FC = () => {
    // Specify the options of this list:
    const query = {
        endpoint: 'get_form_list',
        defaultParams: { deleted: false },
        object: 'form'
    };
    const objectName = 'form.general.object_name';

    // Set isPaginated to true if this list may have 100.000+ items:
    const isPaginated = true

    // Specify form, detail modal or detailpage for this list
    const onRowClick = 'detailPage'
    const detailPageUrl = 'settings/custom-fields/form-builder/form';

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        {
            width: '1fr',
            field: 'name',
            label: 'form.general.name_label',
        },
        // {
        //     width: '2fr',
        //     field: 'description',
        //     label: 'form.general.description_label',
        // },
    ];

    // Specify the filters of this list:
    const filters: ListFilterType[] = [
        {
            id: 'active',
            label: 'form.general.active_form_templates_label',
            params: { 'deleted': false }
        },
        {
            id: 'deleted',
            label: 'form.general.deleted_form_templates_label',
            params: { 'deleted': true }
        }
    ];

    return (
        <AbstractList
            query={query}
            objectName={objectName}
            columns={columns}
            showSearch={false}
            filters={filters}
            isPaginated={isPaginated}
            getFormModal={() => <FormTemplateLibraryModal />}
            getModalSize={() => 'medium'}
            onRowClick={onRowClick}
            detailPageUrl={detailPageUrl}
        />
    );
};

export default FormList;